/**
 * LES APPELS DES RELANCES PENNYLANE — lot 156, 03/11/2026. Routes du lot 155
 * et 156 (`apps/api/src/relances_pl.ts`). Même contrat que `api.ts`.
 */

import { appeler, echec, type Resultat } from './api.js';
import type { FileRelances, LigneRelance, NiveauPl } from './relancesPl.js';

export async function lireFileRelances(jeton: string): Promise<Resultat<FileRelances>> {
  const e = await appeler('/relances-pl', jeton);
  if (e.etat !== 'succes') return echec(e);
  return { etat: 'ok', valeur: e.corps as FileRelances };
}

export interface CourrielPrepare {
  readonly niveau: NiveauPl;
  readonly sujet: string;
  readonly texte: string;
  readonly destinataires: readonly string[];
  readonly copie: readonly string[];
}

export async function preparerCourrielRelance(
  jeton: string,
  pennylaneId: string,
): Promise<Resultat<CourrielPrepare>> {
  const e = await appeler(`/relances-pl/${encodeURIComponent(pennylaneId)}/courriel`, jeton);
  if (e.etat !== 'succes') return echec(e);
  return { etat: 'ok', valeur: e.corps as CourrielPrepare };
}

export interface IssueEnvoiRelance {
  readonly parti: boolean;
  readonly message: string;
  readonly sujet: string;
}

export async function envoyerRelance(
  jeton: string,
  pennylaneId: string,
  envoi: {
    readonly niveau: NiveauPl;
    readonly destinataires: readonly string[];
    readonly copie: readonly string[];
    readonly piece_nom: string;
    readonly piece_base64: string;
    readonly joindre_facture: boolean;
  },
): Promise<Resultat<IssueEnvoiRelance>> {
  const e = await appeler(`/relances-pl/${encodeURIComponent(pennylaneId)}/envoyer`, jeton, {
    methode: 'POST',
    corps: envoi,
  });
  if (e.etat !== 'succes') return echec(e);
  return { etat: 'ok', valeur: e.corps as IssueEnvoiRelance };
}

export async function noterHorsStafa(
  jeton: string,
  pennylaneId: string,
  niveau: NiveauPl,
  envoyeeLe: string,
): Promise<Resultat<LigneRelance | null>> {
  const e = await appeler(`/relances-pl/${encodeURIComponent(pennylaneId)}/hors-stafa`, jeton, {
    methode: 'POST',
    corps: { niveau, envoyee_le: envoyeeLe },
  });
  if (e.etat !== 'succes') return echec(e);
  return { etat: 'ok', valeur: e.corps as LigneRelance | null };
}

export async function gelerRelance(
  jeton: string,
  pennylaneId: string,
  gel: { readonly motif: string; readonly reprise_le: string; readonly note: string | null },
): Promise<Resultat<LigneRelance | null>> {
  const e = await appeler(`/relances-pl/${encodeURIComponent(pennylaneId)}/gel`, jeton, {
    methode: 'POST',
    corps: gel,
  });
  if (e.etat !== 'succes') return echec(e);
  return { etat: 'ok', valeur: e.corps as LigneRelance | null };
}

export async function leverGelRelance(
  jeton: string,
  pennylaneId: string,
): Promise<Resultat<LigneRelance | null>> {
  const e = await appeler(`/relances-pl/${encodeURIComponent(pennylaneId)}/gel`, jeton, {
    methode: 'DELETE',
  });
  if (e.etat !== 'succes') return echec(e);
  return { etat: 'ok', valeur: e.corps as LigneRelance | null };
}
